export const SYSTEM_SEGMENTS = "SET_SYSTEM_SEGMENTS";

export const setSystemSegments = (systemSegments) => {
	return {
		type: SYSTEM_SEGMENTS,
		systemSegments,
	};
};
